import React, { useCallback, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useStripAuth0CallbackParams } from "../../hooks/useStripAuth0CallbackParams";
import {
  MainWrapper,
  FormWrapper,
  LogoContainer,
  FormTitle,
  FormSubtitle,
  FormFooter,
  Footer,
  SignInButton,
  SignInButtonWrapper,
} from "./Signin.styled";
import { Loading } from "../loading";
import { SigninGlobalStyles } from "./SigninGlobalStyles";
import { AnimatedGradientBackground } from "./components";
import LogoAimsos from "../../elements/icon/assets/logo_AIMSOS.svg";

const Signin = ({ children }) => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

  useStripAuth0CallbackParams();

  useEffect(() => {
    if (window.toggleJSDWidget) {
      window.toggleJSDWidget();
    }
  }, []);

  const handleLogin = useCallback(() => {
    const params = new URLSearchParams(window.location.search);
    const authorizationParams = {};
    const invitation = params.get("invitation");
    const organization = params.get("organization");
    if (invitation) {
      authorizationParams.invitation = invitation;
    }
    if (organization) {
      authorizationParams.organization = organization;
    }

    if (Object.keys(authorizationParams).length > 0) {
      loginWithRedirect({ authorizationParams });
    } else {
      loginWithRedirect();
    }
  }, [loginWithRedirect]);

  return (
    <>
      <SigninGlobalStyles />
      {isLoading && <Loading />}
      {!isLoading && isAuthenticated ? (
        children
      ) : (
        <MainWrapper>
          <AnimatedGradientBackground />
          <FormWrapper>
            <LogoContainer>
              <img src={LogoAimsos} alt="AIMS OS Logo" />
            </LogoContainer>
            <FormTitle>Welcome back</FormTitle>
            <FormSubtitle>
              Sign in to access your account and continue with the ANN experience.
            </FormSubtitle>
            <SignInButtonWrapper>
              <SignInButton type="button" onClick={handleLogin}>
                Sign in
              </SignInButton>
            </SignInButtonWrapper>
          </FormWrapper>
          <FormFooter>
            <a
              href="https://aims.ai/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy policy
            </a>
            <div className="divider"></div>
            <a
              href="https://aims.ai/terms-of-use"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of use
            </a>
          </FormFooter>
          <Footer>Powered by AIMS OS</Footer>
        </MainWrapper>
      )}
    </>
  );
};

export default Signin;
